import {$$} from '@vue-macros/reactivity-transform/macros'
import {IFilter} from '@toolify/server/src/services/FilterService/types/IFilter'
import {FilterItemType} from '@toolify/server/src/services/FilterService/enum/FilterItemType'
import {FilterPropertyOperator} from '@toolify/server/src/services/FilterService/enum/FilterPropertyOperator'
import {FilterPropertyPayloadType} from '@toolify/server/src/services/FilterService/enum/FilterPropertyPayloadType'
import {IDatabaseGroupItemResponseInstance} from '@toolify/server/src/controllers/DatabaseItemController/validators/GetGroups/types/IDatabaseGroupItemResponseInstance'
import {IVotePropertyTypeInterfaces} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/VotePropertyTypeStrategy/types/IVotePropertyTypeInterfaces'

export function useVotePropertyTypeStrategy() {
  const resolveGroupCount = (groupItem: IDatabaseGroupItemResponseInstance): number => {
    const groupValue = (groupItem?.value ?? null) as unknown
    if(groupValue && typeof groupValue === 'object') {
      return Number((groupValue as IVotePropertyTypeInterfaces['fullValue']).count) || 0
    }
    const fullValue = (groupItem?.fullValue ?? null) as unknown
    if(fullValue && typeof fullValue === 'object') {
      return Number((fullValue as IVotePropertyTypeInterfaces['fullValue']).count) || 0
    }
    return Number(groupValue) || 0
  }

  const getGroupFilter = (group: string, groupItem: IDatabaseGroupItemResponseInstance, _showAllDatabaseGroups: boolean): IFilter => {
    const count = resolveGroupCount(groupItem)
    if(count === 0) {
      return {
        type: FilterItemType.Property,
        id: group,
        operator: {
          type: FilterPropertyOperator.In,
        },
        subProperty: 'count',
        payload: {
          type: FilterPropertyPayloadType.Static,
          value: [null, 0],
        },
        isDisabled: false,
      }
    }
    return {
      type: FilterItemType.Property,
      id: group,
      operator: {
        type: FilterPropertyOperator.Equals,
      },
      subProperty: 'count',
      payload: {
        type: FilterPropertyPayloadType.Static,
        value: count,
      },
      isDisabled: false,
    }
  }

  return $$({
    getGroupFilter,
  })
}
